<template>
  <el-popover
    v-model="visible"
    class="ips-org-tree"
    placement="bottom-start"
    popper-class="ips-org-tree__popper"
    transition="el-zoom-in-top"
    trigger="click"
    width="200"
    @hide="handleHide"
  >
    <div ref="tree-container" class="ips-org-tree__tree-container">
      <el-tree
        ref="tree"
        :data="data"
        :filter-node-method="filterNode"
        :props="props"
        :show-checkbox="showCheckbox"
        node-key="id"
        @node-click="handleNodeClick"
        @check-change="handleCheckChange"
      ></el-tree>
    </div>
    <el-input
      slot="reference"
      v-model.trim="name"
      :class="{
        'ips-org-tree_arrow-down': !visible,
        'ips-org-tree_arrow-up': visible
      }"
      :clearable="true"
      :placeholder="placeholder"
      class="ips-org-tree__input"
      suffix-icon="el-icon-arrow-up"
      @input="handleInput"
    ></el-input>
  </el-popover>
</template>

<script>
export default {
  name: 'PointListTree',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    props: {
      type: Object
    },

    showCheckbox: {
      type: Boolean,
      default: () => false
    },
    leafOnly: {
      type: Boolean,
      default: () => true
    },
    placeholder: {
      type: String,
      default: () => '选择点位'
    }
  },

  data() {
    return {
      name: '',
      visible: false
    }
  },

  created() {},

  methods: {
    handleHide() {},

    handleCheckChange() {
      /*let nodes = this.$refs.tree.getCheckedNodes(this.leafOnly)
      let value = nodes.map(item => item.id)
      // TODO 如果需要其他的值可以加
      this.emitValue(value, nodes)*/
    },
    emitValue(value, nodes) {
      this.$emit('input', value)
      this.$emit('check-change', nodes)
    },

    handleNodeClick(data) {
      console.log(data[this.props.children])
      if (this.showCheckbox) {
        return
      }

      if (data[this.props.children]) {
        return
      }

      this.name = data[this.props.label]
      this.emitValue(data[this.props.label], data)

      this.$refs.tree.filter('')
      this.visible = false
    },
    filterNode(value, data) {
      if (!value) return true
      return data[this.props.label].indexOf(value) !== -1
    },

    handleInput() {
      console.log(this.name)
      this.visible = true
      // 根据用户的输入过滤树节点
      this.$refs.tree.filter(this.name)
    }
  },

  watch: {}
}
</script>

<style lang="scss">
@import '~@/assets/scss/dropTree.scss';
</style>
